module.exports = __webpack_public_path__ + "media/images/svgs/icon-back-61c3cd85c6d54f68f72f218bbcd74d75.svg";